<template>
  <div>
    <template v-for="item in list">
      <el-submenu
        v-if="item.subMenu && item.subMenu.length > 0"
        :index="item.path"
        :key="item.name"
      >
        <template slot="title">{{ item.name }}</template>

        <menu-item
          :list="item.subMenu"
          :basePath="`${basePath}${item.path}`"
          active-text-color="#666666"
          background-color="transparent"
          @jump="$emit('jump')"
        />
      </el-submenu>

      <!-- 超链接节点 -->
      <!-- 存在url时，无视path -->
      <a v-else :key="item.name" @click="openUrl(item)">
        <el-menu-item>{{ item.name }}</el-menu-item>
      </a>
    </template>
  </div>
</template>

<script>
export default {
  name: 'MenuItem',
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  methods: {
    openUrl(item) {
      if (item.url) {
        window.location.href = item.url
        return
      }
      this.$router.push(`${this.basePath}${item.path}`)
      this.$emit('jump')
    }
  }
}
</script>
